/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
export class EmployeeGroupModel {
  constructor(
    public employeeGroupId: string,
    public name: string,
    public employees: string[],
    public defaultGroup: boolean,
    public startScreenConfiguration: object[],
    public isOnEdit: boolean,
    public supervisors: string[]
  ) {}
}
